// extracted by mini-css-extract-plugin
export default {"card":"bREH_T1t","content":"kNimbYQd","sum":"Gj26fojc","contentElem":"_ATWt5TG"};
    if(module.hot) {
      // 1721070004722
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  